"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putCompanyCode = void 0;
var putCompanyCode = function (instance) {
    return function (body, config) {
        return instance.put("/contacts/company-code/", body, config);
    };
};
exports.putCompanyCode = putCompanyCode;
